(function() {
    window.Station || (window.Station = {
        App: {
            config: {
                mediumScreen: 640,
                largeScreen: 1024
            } 
        }
    }), window.Station.GrandCentral = {
        version: "1.2.9"
    }
}).call(this),
    function() {
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.Utilities = function(t) {
            var e, n, i, o, a, r, c, s, l, u, d, h, f, m, p;
            return c = Station.App.config, t.fn.randomize = function(e) {
                return (e ? this.find(e) : this).parent().each(function() {
                    return t(this).children(e).sort(function() {
                        return Math.random() - .5
                    })
                })
            }, t.fn.randomizeInPlace = function(e) {
                return (e ? this.find(e) : this).parent().each(function() {
                    return t(this).children(e).sort(function() {
                        return Math.random() - .5
                    }).detach().appendTo(this)
                })
            }, r = function(t, e) {
                return "object" == typeof t && "object" == typeof e ? t.length === e.length && t.every(function(t, n) {
                    return t === e[n]
                }) : void 0
            }, s = function(t, e) {
                return setTimeout(e, t)
            }, l = function(t) {
                var e, n;
                return n = new RegExp("[?&]" + t + "((=([^&]*))|(?=(&|$)))", "i"), e = window.location.search.match(n), e && ("undefined" == typeof e[3] ? "" : e[3])
            }, u = function() {
                var t, e;
                return e = window.navigator.userAgent, t = e.indexOf("MSIE "), t > 0 ? parseInt(e.substring(t + 5, e.indexOf(".", t))) : !1
            }, d = function(e, n, i, o) {
                var a, r;
                return a = t.parseJSON(e.responseText), r = a.message + ": " + a.description, o || (o = r), console.log(n), console.log(a)
            }, h = function(t) {
                return t.replace(/http(s)?:/, "")
            }, f = function() {
                var t, e;
                return e = "screen and (max-width: " + c.mediumScreen + "px)", t = "screen and (min-width: " + c.mediumScreen + "px) and (max-width: " + c.largeScreen + "px)", window.matchMedia(e).matches ? "small" : window.matchMedia(t).matches ? "medium" : "large"
            }, m = function(t, e) {
                window.history && window.history.replaceState && o(i(t, e))
            }, p = function(e, n, i) {
                var o;
                (o = t(n)) && (t(e).hide(), o.addClass(i).show())
            }, n = function() {
                return window.location.search
            }, e = function() {
                return window.location.hash
            }, i = function(t, i) {
                var o;
                return o = void 0, o = a(t) ? n().replace(RegExp("(" + t + "=)[^&#]+"), "$1" + i) : "" === n() ? "?" + t + "=" + i : n() + "&" + t + "=" + i, o + e()
            }, o = function(t) {
                window.history.replaceState({}, document.title, t)
            }, a = function(t) {
                var e;
                return e = RegExp("[?&]" + t + "=([^&#]*)").exec(n()), e && decodeURIComponent(e[1].replace(/\+/g, " "))
            }, t("[data-target-new]").attr("target", "_blank"), t("[data-click-history-back]").on("click", function() {
                return window.history.back(), !1
            }), t("[data-auto-focus]").focus(), t("form:not([html-validate])").attr("novalidate", ""), {
                arraysEqual: r,
                delay: s,
                getParam: l,
                msieVersion: u,
                onAjaxError: d,
                removeProtocol: h,
                screenSize: f,
                setParam: m,
                switchElement: p
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.Accordions = function(t) {
            var e, n, i, o;
            return e = ".accordion", n = function(e, n) {
                var i;
                return null == n && (n = !0), i = t(">dt.open", e), n ? i.removeClass("open").next("dd").velocity("slideUp", {
                    duration: 400,
                    easing: "easeOutQuint",
                    queue: !1,
                    complete: function() {
                        return e.data("locked", !1)
                    }
                }) : i.removeClass("open").next("dd").hide(), !1
            }, o = function(t, n) {
                var i;
                return null == n && (n = !0), i = t.closest(e), t.addClass("open"), n ? t.addClass("open").next("dd").velocity("slideDown", {
                    duration: 400,
                    easing: "easeOutQuint",
                    queue: !1,
                    complete: function() {
                        return i.data("locked", !1)
                    }
                }) : t.next("dd").show(), !1
            }, i = function() {
                return t(e).each(function(e) {
                    var i, a, r;
                    return r = this, a = t(">dt", this), i = a.filter(".open"), t(this).data("locked", !1), i.length && i.each(function() {
                        return o(t(this), !1)
                    }), a.each(function() {
                        var e;
                        return e = t(this).closest("dt"), t(">a", this).on("click", function(i) {
                            return i.preventDefault(), t(r).data("locked") || (t(r).data("locked", !0), e.hasClass("open") ? n(t(r)) : (n(t(r)), o(e))), !1
                        })
                    })
                }), !1
            }, t(document).ready(function() {
                return i()
            }), {
                init: i,
                closePanels: n,
                openPanel: o
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.AudioPlayer = function(t) {
            var e, n, i, o, a, r, c;
            return r = "ontouchstart" in window, a = r ? "touchstart" : "mousedown", o = r ? "touchmove" : "mousemove", i = r ? "touchend" : "mouseup", n = r ? "touchcancel" : "mouseup", e = function(t) {
                var e;
                return e = document.createElement("audio"), !(!e.canPlayType || !e.canPlayType("audio/" + t.split(".").pop().toLowerCase() + ";").replace(/no/, ""))
            }, c = function(t) {
                var e, n, i, o, a;
                return n = t / 3600, e = Math.floor(n), o = t % 3600 / 60, i = Math.floor(o), a = Math.ceil(t % 3600 % 60), a > 59 && (a = 0, i = Math.ceil(o)), i > 59 && (i = 0, e = Math.ceil(n)), (0 === e ? "" : e > 0 && e.toString().length < 2 ? "0" + e + ":" : e + ":") + (i.toString().length < 2 ? "0" + i : i) + ":" + (a.toString().length < 2 ? "0" + a : a)
            }, t.fn.audioPlayer = function(i) {
                var s, l, u;
                i = t.extend({
                    classPrefix: "audioplayer",
                    strPlay: "Play",
                    strPause: "Pause",
                    strVolume: "Volume"
                }, i), s = {}, l = {
                    playPause: "playpause",
                    playing: "playing",
                    stopped: "stopped",
                    time: "time",
                    timeCurrent: "time-current",
                    timeDuration: "time-duration",
                    bar: "bar",
                    barLoaded: "bar-loaded",
                    barPlayed: "bar-played",
                    volume: "volume",
                    volumeButton: "volume-button",
                    volumeAdjust: "volume-adjust",
                    noVolume: "novolume",
                    muted: "muted",
                    mini: "mini"
                };
                for (u in l) s[u] = i.classPrefix + "-" + l[u];
                return this.each(function() {
                    var l, u, d, h, f, m, p, y, v, S, g, C, T, w, b, $, I, k, P, x, A;
                    return "audio" !== t(this).prop("tagName").toLowerCase() ? !1 : (l = t(this), h = l.attr("src"), S = !1, y = l.get(0).getAttribute("autoplay"), y = "" === y || "autoplay" === y ? !0 : !1, v = l.get(0).getAttribute("loop"), v = "" === v || "loop" === v ? !0 : !1, "undefined" == typeof h ? t("source", l).each(function() {
                        return h = t(this).attr("src"), "undefined" != typeof h && e(h) ? (S = !0, !1) : void 0
                    }) : e(h) && (S = !0), T = t('<div class="not-fitvid ' + i.classPrefix + '">' + (S ? t("<div>").append(l.eq(0).clone()).html() : '<embed src="' + h + '" width=0 height=0 volume=100 autostart="' + y.toString() + '" type="audio/mpeg" loop="' + v.toString() + '" />') + '<div class="' + s.playPause + '" title="' + i.strPlay + '"><a href="#">"' + i.strPlay + '"</a></div></div>'), f = S ? "audio" : "embed", g = t(f, T).get(0), S ? (u = function(t) {
                        var e;
                        e = r ? t.originalEvent.touches[0] : t, g.currentTime = Math.round(g.duration * (e.pageX - C.offset().left) / C.width())
                    }, d = function(t) {
                        var e;
                        e = r ? t.originalEvent.touches[0] : t, g.volume = Math.abs((e.pageY - (I.offset().top + I.height())) / I.height())
                    }, $ = function() {
                        var t;
                        t = setInterval(function() {
                            return g.buffered.length < 1 ? !0 : (m.width(g.buffered.end(0) / g.duration * 100 + "%"), void(Math.floor(g.buffered.end(0)) >= Math.floor(g.duration) && clearInterval(t)))
                        }, 100)
                    }, P = 0, t("audio", T).css({
                        width: 0,
                        height: 0,
                        visibility: "hidden"
                    }), T.append('<div class="' + s.time + " " + s.timeCurrent + '"></div><div class="' + s.bar + '"><div class="' + s.barLoaded + '"></div><div class="' + s.barPlayed + '"></div></div><div class="' + s.time + " " + s.timeDuration + '"></div><div class="' + s.volume + '"><div class="' + s.volumeButton + '" title="' + i.strVolume + '"><a href="#">"' + i.strVolume + '"</a></div><div class="' + s.volumeAdjust + '"><div><div></div></div></div></div>'), C = t("." + s.bar, T), p = t("." + s.barPlayed, T), m = t("." + s.barLoaded, T), w = t("." + s.timeCurrent, T), b = t("." + s.timeDuration, T), k = t("." + s.volumeButton, T), I = t("." + s.volumeAdjust + " > div", T), x = g.volume, A = g.volume = .111, Math.round(1e3 * g.volume) / 1e3 === A ? g.volume = x : T.addClass(s.noVolume), b.html("&hellip;"), w.html(c(0)), g.addEventListener("loadeddata", function() {
                        $(), b.html(t.isNumeric(g.duration) ? c(g.duration) : "&hellip;"), I.find("div").height(100 * g.volume + "%"), P = g.volume
                    }), g.addEventListener("timeupdate", function() {
                        w.html(c(g.currentTime)), p.width(g.currentTime / g.duration * 100 + "%")
                    }), g.addEventListener("volumechange", function() {
                        I.find("div").height(100 * g.volume + "%"), g.volume > 0 && T.hasClass(s.muted) && T.removeClass(s.muted), g.volume <= 0 && !T.hasClass(s.muted) && T.addClass(s.muted)
                    }), g.addEventListener("ended", function() {
                        T.removeClass(s.playing).addClass(s.stopped)
                    }), C.on(a, function(t) {
                        u(t), C.on(o, function(t) {
                            u(t)
                        })
                    }).on(n, function() {
                        C.unbind(o)
                    }), k.on("click", function() {
                        return T.hasClass(s.muted) ? (T.removeClass(s.muted), g.volume = P) : (T.addClass(s.muted), P = g.volume, g.volume = 0), !1
                    }), I.on(a, function(t) {
                        d(t), I.on(o, function(t) {
                            d(t)
                        })
                    }).on(n, function() {
                        I.unbind(o)
                    })) : T.addClass(s.mini), T.addClass(y ? s.playing : s.stopped), t("." + s.playPause, T).on("click", function() {
                        return T.hasClass(s.playing) ? (t(this).attr("title", i.strPlay).find("a").html(i.strPlay), T.removeClass(s.playing).addClass(s.stopped), S ? g.pause() : g.Stop()) : (t(this).attr("title", i.strPause).find("a").html(i.strPause), T.addClass(s.playing).removeClass(s.stopped), S ? g.play() : g.Play()), !1
                    }), void l.replaceWith(T))
                })
            }, t(document).ready(function() {
                return t("audio").audioPlayer()
            })
        }(jQuery.noConflict())
    }.call(this),
    function() {
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.Notify = function(t) {
            var e, n, i, o, a, r, c, s, l, u, d;
            return i = "easeOutCirc", o = "easeInExpo", r = "", c = '<div id="notify-bar"><div class="message"></div><a href="#" class="close" data-close>&times;</div>', l = 6e3, u = "timer", d = 300, e = {}, a = function() {
                return t("body").prepend(c), e = t("#notify-bar"), e.hide()
            }, n = function() {
                var t;
                return t = e.hasClass("inline"), t ? e.velocity({
                    "margin-top": -e.outerHeight()
                }, {
                    duration: d / 1.5,
                    easing: o,
                    queue: !1,
                    complete: function() {
                        return e.hide().find(".message").html("")
                    }
                }) : e.velocity({
                    translateY: "-100%"
                }, {
                    duration: d / 1.5,
                    easing: o,
                    queue: !1,
                    complete: function() {
                        return clearTimeout(r), e.removeAttr("style").hide().find(".message").html("")
                    }
                })
            }, s = function(o, a, c, s, h, f) {
                return a || (a = "slate"), c || (c = l), s || (s = !1), h || (h = !1), f || (f = !1), clearTimeout(r), t(".message", e).html(o), t("." + u, e).remove(), e.removeClass("inline").removeAttr("style").attr("class", a), t("a[data-close]", e).on("click", function(t) {
                    return t.preventDefault(), n()
                }), h ? e.addClass("inline").show().velocity({
                    "margin-top": [0, -e.outerHeight()]
                }, {
                    duration: d,
                    easing: i,
                    queue: !1
                }) : e.show().velocity({
                    translateY: [0, "-100%"]
                }, {
                    duration: d,
                    easing: i,
                    queue: !1
                }), !s && (r = setTimeout(n, c), f) ? t("<div>").addClass(u).prependTo(e).velocity({
                    width: ["100%", 0]
                }, {
                    duration: c,
                    easing: "linear",
                    queue: !1
                }) : void 0
            }, t(document).ready(function() {
                return a()
            }), t(document).on("keydown", function(t) {
                27 === t.keyCode && n()
            }), {
                init: a,
                close: n,
                open: s
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.NavPrimary = function(t) {
            var e, n, i, o, a, r, c, s, l, u, d;
            return e = "nav-active", a = "nav-level", r = ".nav-primary", c = ".nav-toggle", s = "nav-node", l = "nav-open", i = {
                easing: "easeOutCirc",
                nodeTransitionDuration: 300
            }, n = function(t) {
                t.closest("li").removeClass(l).end().velocity("stop").velocity({
                    height: 0
                }, {
                    display: "none",
                    duration: i.nodeTransitionDuration,
                    easing: i.easing,
                    queue: !1
                })
            }, u = function(e) {
                e.closest("li").addClass(l).end().css({
                    height: "auto"
                }).velocity("stop").velocity({
                    height: [e.outerHeight(), 0]
                }, {
                    display: "block",
                    duration: i.nodeTransitionDuration,
                    easing: i.easing,
                    queue: !1,
                    complete: function() {
                        t(this).css("height", "auto")
                    }
                })
            }, d = function() {
                t(r).each(function() {
                    return t("ul", this).removeAttr("style"), t("." + l, this).removeClass(l)
                })
            }, o = function() {
                t(r).each(function() {
                    var e, i, o, r, d;
                    d = this, r = t(this).data("nav-id"), e = t("ul", this), i = t("> ul", this).first(), o = t(c + "[data-nav-id='" + r + "']"), e.each(function() {
                        var e, i;
                        return i = this, e = parseInt(t(this).parentsUntil(d, "ul").length + 1), t(this).addClass(a + "-" + e).closest("li").addClass(s).attr("aria-haspopup", !0).children(":first-child").on("mouseover", function(t) {
                            return t.stopPropagation()
                        }).on("click", function(e) {
                            ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch) && (t(this).data("nav-item-touched") !== !0 ? (e.preventDefault(), t(this).data("nav-item-touched", !0), u(t(i))) : !t(i).closest("li").hasClass(l) || "" !== t(this).attr("href") && "#" !== t(this).attr("href") || (e.preventDefault(), t(this).data("nav-item-touched", !1), n(t(i))))
                        })
                    }), o.on("click", function(e) {
                        return i.hasClass(l) ? (t(this).removeClass(l), i.removeClass(l), n(i)) : (t(this).addClass(l), i.addClass(l), u(i))
                    })
                })
            }, t(document).ready(function() {
                var e;
                return e = t(window).width(), o(), t(window).on("resize", function() {
                    return t(window).width() !== e ? (e = t(window).width(), d()) : void 0
                })
            }), {
                init: o,
                closeNode: n,
                openNode: u,
                reset: d
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.NavSide = function(t) {
            var e, n, i, o, a, r, c, s, l, u, d;
            return e = "nav-active", r = "nav-level", c = ".nav-side", s = "nav-node", l = "nav-open", o = {
                closeKin: !1,
                easingKin: "easeInOutCirc",
                easing: "easeOutCirc",
                nodeTransitionDuration: 300
            }, n = function(e) {
                var n, a;
                a = e.closest(c).data("node-transition-duration"), a || o.nodeTransitionDuration, n = e.closest("li").siblings("." + l).find("ul"), n.each(function() {
                    i(t(this), a, !0)
                })
            }, i = function(t, e, n) {
                e = "undefined" != typeof e ? e : o.nodeTransitionDuration, t.closest("li").removeClass(l), e > 0 ? t.velocity("stop").velocity({
                    height: 0
                }, {
                    display: "none",
                    duration: e,
                    easing: n ? o.easingKin : o.easing,
                    queue: !1
                }) : t.css({
                    height: 0
                }).hide()
            }, u = function(e, i, a) {
                i = "undefined" != typeof i ? i : o.nodeTransitionDuration, a = "undefined" != typeof a ? a : o.closeKin, e.closest("li").addClass(l).end().css({
                    height: "auto"
                }), i > 0 ? e.velocity("stop").velocity({
                    height: [e.outerHeight(), 0]
                }, {
                    display: "block",
                    duration: i,
                    easing: a ? o.easingKin : o.easing,
                    queue: !1,
                    complete: function() {
                        t(this).css("height", "auto")
                    }
                }) : e.show(), a && n(e)
            }, d = function(t, e, n) {
                e = "undefined" != typeof e ? e : o.nodeTransitionDuration, n = "undefined" != typeof n ? n : o.closeKin, t.closest("li").hasClass(l) ? i(t, e, n) : u(t, e, n)
            }, a = function() {
                return t(c).each(function() {
                    var e, n, i, o, a;
                    a = this, n = t(this).data("close-kin"), i = t(this).data("expanded"), o = t(this).data("node-transition-duration"), e = t("ul", this), t(this).addClass(r + "-1"), e.each(function() {
                        var e, c, h;
                        return h = this, c = parseInt(t(this).parentsUntil(a, "ul").length + 2), t(this).addClass(r + "-" + c), i && t(this).closest("li").addClass(l).end().css({
                            height: "auto",
                            display: "block"
                        }), t(this).closest("li").addClass(s).children(":first-child").on("click", function(e) {
                            ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch) && (t(this).data("nav-item-touched") !== !0 ? (e.preventDefault(), t(this).data("nav-item-touched", !0), d(t(h), o, n)) : !t(h).closest("li").hasClass(l) || "" !== t(this).attr("href") && "#" !== t(this).attr("href") || (e.preventDefault(), t(this).data("nav-item-touched", !1), d(t(h), o, n)))
                        }), t(this).closest("li").hasClass(l) ? (e = t(h).parentsUntil(a, "ul"), e.push(t(h)), e.each(function() {
                            return u(t(this), 0, !1)
                        })) : void 0
                    })
                })
            }, t(document).ready(function() {
                return a()
            }), {
                init: a,
                closeNode: i,
                openNode: u,
                toggleNode: d
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        Station.GrandCentral = Station.GrandCentral || {}, Station.GrandCentral.Tabs = function(t) {
            var e, n, i, o, a, r, c;
            return i = "open", c = ".tabs", r = ".tab", a = ".tab-title", o = function(t) {
                return t.hasClass(i) ? void 0 : t.addClass(i)
            }, e = function(e) {
                var n;
                return n = t(r + "." + i, e), n.removeClass(i)
            }, n = function() {
                return t(c).each(function(n) {
                    var c, s;
                    return s = this, c = t(r + "." + i, this), c.length || o(t(r, this).first(), !1), t(this).on("click", a, function(n) {
                        var a;
                        return a = t(this).closest(r), n.preventDefault(), a.hasClass(i) ? void 0 : (e(s), o(a))
                    })
                })
            }, t(document).ready(function() {
                return n()
            }), {
                init: n,
                closeTabs: e,
                openTab: o
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        Station.GrandCentral.Vendor = Station.GrandCentral.Vendor || {}, Station.GrandCentral.Vendor.FancyBox = function(t) {
            var e, n, i;
            return e = function(e) {
                e.transitions.grandCentralIn = function() {
                    var t;
                    t = 20, e.wrap.velocity({
                        opacity: [1, 0],
                        translateY: [0, -t]
                    }, {
                        duration: e.current.openSpeed,
                        easing: e.current.openEasing,
                        complete: e._afterZoomIn
                    })
                }, e.transitions.grandCentralOut = function() {
                    var t;
                    t = 20, e.wrap.removeClass("fancybox-opened").velocity({
                        opacity: 0,
                        translateY: -t
                    }, {
                        duration: e.current.closeSpeed,
                        easing: e.current.closeEasing,
                        complete: function() {
                            return e._afterZoomOut()
                        }
                    })
                }, e.transitions.grandCentralChangeIn = function() {
                    var t, n, i, o;
                    t = e.direction, n = 60, "left" === t && (i = [0, n], o = 0), "right" === t && (i = [0, -n], o = 0), "up" === t && (i = 0, o = [0, n]), "down" === t && (i = 0, o = [0, -n]), e.wrap.velocity({
                        opacity: [1, 0],
                        translateX: i,
                        translateY: o
                    }, {
                        duration: e.current.nextSpeed,
                        easing: e.current.nextEasing,
                        complete: e._afterZoomIn
                    })
                }, e.transitions.grandCentralChangeOut = function() {
                    var n, i, o, a;
                    n = e.direction, i = 60, "left" === n && (o = -i, a = 0), "right" === n && (o = i, a = 0), "up" === n && (o = 0, a = -i), "down" === n && (o = 0, a = i), e.previous.wrap.velocity({
                        opacity: 0,
                        translateX: o,
                        translateY: a
                    }, {
                        duration: e.current.prevSpeed,
                        easing: e.previous.easing,
                        complete: function() {
                            return t(this).trigger("onReset").remove()
                        }
                    })
                }
            }, i = function() {
                return t.extend(t.fancybox.defaults, {
                    closeBtn: !1,
                    closeEasing: "easeInCirc",
                    closeMethod: "grandCentralOut",
                    closeSpeed: 200,
                    nextEasing: "easeInOutCirc",
                    nextMethod: "grandCentralChangeIn",
                    nextSpeed: 300,
                    openEasing: "easeOutCirc",
                    openMethod: "grandCentralIn",
                    openSpeed: 500,
                    padding: 0,
                    prevEasing: "easeInOutCirc",
                    prevMethod: "grandCentralChangeOut",
                    prevSpeed: 300,
                    wrapCSS: "fancybox-grand-central",
                    helpers: {
                        overlay: {
                            css: {
                              
                                background: "rgba(255, 255, 255, 0.94)"
                            }
                        },
                        title: {
                            type: "inside"
                        },
                        media: {}
                    },
                    beforeLoad: function() {
                        var t, e;
                        return t = parseInt(this.element.data("fancybox-height")), e = parseInt(this.element.data("fancybox-width")), e && (this.width = e), t ? this.height = t : void 0
                   
                    },
                    afterLoad: function() {
                        t(".fancybox-overlay").addClass(this.wrapCSS)
                        t('.fancybox-inner').hide();
                      t.removeData($('.zoom_01'), 'elevateZoom');
                      t('.zoomContainer').remove();
                    },
                    afterShow: function() {
                      t('.fancybox-inner').show();
                        t("[data-modal-close]", this.inner).on("click", function(e) {
                            return e.preventDefault(), t.fancybox.close()
                        }), t(".fancybox-overlay > .fancybox-close-wrap").length || "modal" !== this.element.data("modal-type") && t('<div class="fancybox-close-wrap" />').html('<div class="fancybox-close"><i class="fa fa-close"></div>').prependTo(t(".fancybox-overlay")).on("click", function(e) {
                            return e.preventDefault(),
                            t.fancybox.close(),
                            t.removeData($('.zoom_01'), 'elevateZoom'),
                           t('.zoomContainer').remove()
                        }), t(".fancybox-nav", this.wrap).length && (t(".fancybox-overlay > .fancybox-nav-prev-wrap").length || (t('<div class="fancybox-nav-prev-wrap" />').html('<div class="fancybox-nav-prev"><i class="fa fa-caret-left"></div>').prependTo(t(".fancybox-overlay")).on("click", function() {
                            return t.fancybox.prev()
                        }), t('<div class="fancybox-nav-next-wrap" />').html('<div class="fancybox-nav-next"><i class="fa fa-caret-right"></div>').prependTo(t(".fancybox-overlay")).on("click", function() {
                            return t.fancybox.next()
                        })), this.wrap.hasClass("fancybox-type-ajax") && t(".fancybox-nav", this.outer).hide())
                        var imgsrc = t('.fancybox-image').attr('src');
                        t('.fancybox-image').addClass('zoom_01');
                      t('.fancybox-image').attr('data-zoom-image',imgsrc);
                      $('.zoom_01').elevateZoom({
                        zoomType: "inner",
                        cursor: "crosshair"
                      }); 
                        console.log('showele '+ imgsrc);
                    },
                    beforeClose: function() {
                        t(".fancybox-overlay").addClass("fancybox-closing")
                    }
                })
            }, n = function() {
                return t(".fancybox").fancybox(), t('.fancybox[data-modal-type="modal"]').fancybox({
                    modal: !0
                })
            }, t(document).ready(function() {
                return "function" == typeof jQuery.fn.fancybox ? (e(jQuery.fancybox), i(), n()) : void 0
            })
        }(jQuery.noConflict())
    }.call(this),
    function() {
        Station.GrandCentral.Vendor = Station.GrandCentral.Vendor || {}, Station.GrandCentral.Vendor.Flickity = function(t) {
            var e, n, i, o, a, r, c;
            return c = {
                attr: {
                    options: "data-flickity-options"
                },
                carousel: ".gc-carousel"
            }, i = {
                defaultOptions: {
                    arrowShape: "M65.0491632,29.3794051 C66.0536287,28.3749397 66.0536287,26.7677949 65.0491632,25.7633294 L58.3795124,19.0936786 C57.3750469,18.0892131 55.7679022,18.0892131 54.7634367,19.0936786 L24.9509011,48.9062141 C23.9464357,49.9106796 23.9464357,51.5178244 24.9509011,52.5222899 L54.7634367,82.3348254 C55.7679022,83.3392909 57.3750469,83.3392909 58.3795124,82.3348254 L65.0491632,75.6651746 C66.0536287,74.6607091 66.0536287,73.0535643 65.0491632,72.0490989 L43.7143164,50.714252 L65.0491632,29.3794051 Z",
                    autoPlay: 5e3,
                    cellAlign: "center",
                    cellSelector: ".gc-carousel-cell",
                    contain: !0,
                    draggable: !0,
                    freeScroll: !1,
                    freeScrollFriction: .03,
                    friction: .28,
                    initialIndex: 0,
                    lazyLoad: 1,
                    pauseAutoPlayOnHover: !0,
                    pageDots: !0,
                    prevNextButtons: !0,
                    selectedAttraction: .025,
                    wrapAround: !0
                }
            }, e = {}, o = function() {
                n(), r()
            }, n = function() {
                e = {
                    $carousels: t(c.carousel)
                }
            }, r = function() {
                e.$carousels.length && e.$carousels.each(function() {
                    return a(t(this))
                })
            }, a = function(e, n) {
                var o;
                null == n && (n = {}), o = e.attr("data-flickity-options"), o && (o = JSON.parse(o)), n = t.extend(i.defaultOptions, o, n), e.flickity(n)
            }, t(function() {
                o()
            }), {
                init: o,
                cacheElements: n,
                initCarousel: a,
                initCarousels: r
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        window.Station.Theme = window.Station.Theme || {}, Station.Theme.Base = function(t) {
            var e, n, i, o, a, r, c, s, l, u, d, h;
            return l = {
                pageTitle: ".page-header .title",
                toggleTopBarSearch: "a[data-toggle-top-bar-search]",
                topBarSearch: "#top-bar-search"
            }, i = {
                windowResizingID: void 0
            }, d = Station.Theme.config, e = {}, o = function() {
                return n(), c(), a(), r(), s()
            }, n = function() {
                return e = {
                    $pageTitle: t(l.pageTitle),
                    $toggleTopBarSearch: t(l.toggleTopBarSearch),
                    $topBarSearch: t(l.topBarSearch)
                }
            }, a = function() {
                "function" == typeof t.fn.fitVids && t(".fit-video").fitVids()
            }, r = function() {
                return t("select.jump-menu").change(function() {
                    window.location = t("option:selected", this).val()
                })
            }, c = function() {
                var t, e, n;
                if (Shopify.queryParams = {}, location.search.length)
                    for (e = void 0, n = 0, t = location.search.substr(1).split("&"); n < t.length;) e = t[n].split("="), e.length > 1 && (Shopify.queryParams[decodeURIComponent(e[0])] = decodeURIComponent(e[1])), n++
            }, s = function() {
                e.$toggleTopBarSearch.on("click", function(t) {
                    return t.preventDefault(), h()
                })
            }, u = function(t) {
                null == t && (t = e.$pageTitle.data("default-text")), e.$pageTitle.text(t)
            }, h = function() {
                var n, i;
                i = e.$topBarSearch, n = t("input:first", i), i.is(":visible") ? i.velocity({
                    "margin-top": -i.outerHeight()
                }, {
                    duration: 400,
                    easing: "easeOutCirc",
                    queue: !1,
                    complete: function() {
                        return i.hide()
                    }
                }) : (Station.GrandCentral.Utilities.delay(20, function() {
                    return n.focus().on("focusout", function() {
                        return h()
                    })
                }), t("body").velocity("scroll", {
                    duration: 400,
                    offset: 0,
                    easing: "easeOutCirc"
                }), i.show().velocity({
                    "margin-top": [0, -i.outerHeight()]
                }, {
                    duration: 400,
                    easing: "easeOutCirc",
                    queue: !1
                }))
            }, t(function() {
                o()
            }), {
                init: o,
                initFitVids: a,
                initJumpMenus: r,
                initShopifyExtensions: c,
                initToggleTopBarSearch: s,
                cacheElements: n,
                setPageTitle: u,
                toggleTopBarSearch: h
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.Cart = function(t) {
            var e, n, i, o, a, r, c, s, l, u, d;
            return l = {
                attr: {
                    cartAction: "data-cart-action"
                },
                addToCart: ".add-to-cart",
                addToCartForm: "form[action^=/cart/add]",
                cartBadge: ".cart-badge"
            }, r = Station.Theme.current, u = Station.Theme.config, a = {
                i18n: Station.Theme.i18n,
                notify: Station.GrandCentral.Notify
            }, i = {}, c = function(t) {
                return o(), e()
            }, o = function() {
                return i = {
                    $addToCart: t(l.addToCart),
                    $cartBadge: t(l.cartBadge)
                }
            }, n = function(e, n) {
                var i, o, r;
                if (e || n) switch (i = t(n), o = i.closest(l.addToCartForm), r = o.serialize(), e) {
                    case "notification":
                        i.blur(), t.ajax({
                            type: "POST",
                            url: "/cart/add.js",
                            data: r,
                            dataType: "json",
                            success: function(t) {
                                d(), a.notify.open(s(t), "success")
                            },
                            error: function(t, e) {
                                var n;
                                n = JSON.parse(t.responseText), a.notify.open(n.description, "error")
                            }
                        });
                        break;
                    default:
                        return
                }
            }, s = function(t) {
                var e, n;
                return n = '<div class="actions"><a class="button small" href="/cart">' + a.i18n.cart.notification.viewCartLink + "</a></div>", e = a.i18n.cart.notification.productAdded, e = e.replace("{{ product_title }}", t.title), e = e.replace("{{ view_cart_link }}", n)
            }, d = function() {
                t.ajax({
                    type: "GET",
                    url: "/cart.js",
                    dataType: "json",
                    success: function(e) {
                        var n, o;
                        switch (e.item_count) {
                            case 0:
                                n = "zero";
                                break;
                            case 1:
                                n = "one";
                                break;
                            default:
                                n = "other"
                        }
                        return o = a.i18n.cart.itemCount[n].replace("{{ count }}", e.item_count), t(".cart-item-count").html(e.item_count), t(".cart-item-count-items").html(o), t(".cart-total-price").html(Station.Theme.Currency.formatMoney(e.total_price)), e.item_count > 0 ? i.$cartBadge.removeClass("empty") : i.$cartBadge.addClass("empty")
                    }
                })
            }, e = function() {
                i.$addToCart.each(function() {
                    return t(this).on("click", function(e) {
                        var i;
                        switch (i = t(this).attr(l.attr.cartAction)) {
                            case "notification":
                                return e.preventDefault(), t(this).blur(), n(i, this)
                        }
                    })
                })
            }, t(function() {
                c()
            }), {
                init: c,
                addToCart: n
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.Collection = function(t) {
            var e, n, i, o, a, r, c;
            return r = {
                listCollections: ".list-collections",
                products: ".collection-products",
                sortBy: "select.sort-collection-by"
            }, c = Station.Theme.config, n = {}, o = function() {
                i(), a(), c.collection.enableEvenRows && e()
            }, i = function() {
                n = {
                    $sortBy: t(r.sortBy),
                    $listCollections: t(r.listCollections),
                    $products: t(r.products)
                }
            }, e = function() {
                n.$products.length && (t(r.products + " .image").matchHeight(), t(r.products + " .title").matchHeight(), t(r.products + " .pricing").matchHeight()), n.$listCollections.length && t(".collection-title").matchHeight()
            }, a = function() {
                n.$sortBy.length && n.$sortBy.each(function() {
                    var e, n;
                    e = t(this), n = e.attr("data-sort-by"), t(this).val(n).on("change", function() {
                        Shopify.queryParams.sort_by = e.val(), location.search = t.param(Shopify.queryParams).replace(/\+/g, "%20")
                    })
                })
            }, t(function() {
                o()
            }), {
                init: o,
                cacheElements: i,
                alignRows: e,
                initSortMenus: a
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        var t;
        Station.Theme = Station.Theme || {}, Station.Theme.CollectionSection = function(t) {
            var e;
            return e = function(e) {
                this.$container = t(e), this.sectionId = this.$container.attr("data-section-id")
            }
        }(jQuery.noConflict()), Station.Theme.CollectionSection.prototype = _.assignIn({}, Station.Theme.CollectionSection.prototype, t = jQuery, {
            onSelect: function(t) {
                return Station.Theme.Cart.init(), Station.Theme.Collection.init(), Station.Theme.Currency.init()
            }
        })
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.Currency = function(t) {
            var e, n, i, o, a, r, c, s, l, u, d;
            return l = {
                attr: {
                    basePrice: "data-base-price"
                },
                currencyCode: "[data-currency-code]",
                currencySelect: "[data-currency-selector]",
                singleOptionSelector: '[name="id"][data-option-selector]',
                price: "[data-price]"
            }, d = Station.Theme.config, o = {
                currentCurrency: Station.Theme.current.currency,
                moneyFormat: Station.Theme.shop.moneyFormat,
                moneyWithCurrencyFormat: Station.Theme.shop.moneyWithCurrencyFormat,
                shop: Station.Theme.shop,
                shopCurrency: Station.Theme.shop.currency
            }, n = {}, c = function() {
                var t;
                i(), e(), Currency.moneyFormats[o.shopCurrency].money_format = o.moneyFormat, Currency.moneyFormats[o.shopCurrency].money_with_currency_format = o.moneyWithCurrencyFormat, t = d.enableMultiCurrency && d.defaultCurrency ? d.defaultCurrency : o.shopCurrency, d.enableMultiCurrency && Currency.cookie.read() && (t = Currency.cookie.read()), Currency.currentCurrency = t, u(t)
            }, i = function() {
                return n = {
                    $currencyCode: t(l.currencyCode),
                    $currencySelect: t(l.currencySelect),
                    $price: t(l.price),
                    $singleOptionSelector: t(l.singleOptionSelector)
                }
            }, a = function(e) {
                null == e && (e = Currency.currentCurrency), n.$price.each(function() {
                    return s(this, t(this).attr(l.attr.basePrice), "", e)
                }), t("option", n.$singleOptionSelector).each(function() {
                    var n, i, o;
                    o = t(this).html(), o = o.substr(0, o.lastIndexOf("—") + 2), i = o.lastIndexOf("—") > 0, n = t(this).attr(l.attr.basePrice), i && (n = n ? r(n, null, e) : Station.Theme.i18n.product.soldOut, t(this).html(o + n))
                })
            }, r = function(t, e, n) {
                var i, a;
                if (!isNaN(parseInt(t))) return t = t ? parseInt(t) : 0, n = n ? n : Currency.currentCurrency, e = e ? e : d.moneyStyle, i = Currency.moneyFormats[n][e], a = Currency.convert(t, o.shopCurrency, n), a = Currency.formatMoney(a, i)
            }, s = function(e, n, i, o) {
                var a, c, s;
                a = t(e), s = a.attr("data-money-style"), ("money_format" === s || "money_with_currency_format" === s) && (i = s), isNaN(parseInt(n)) ? (c = n, n = "") : c = r(n, i, o), a.attr(l.attr.basePrice, n).html(c).addClass("converted")
            }, u = function(t) {
                n.$currencyCode.html(t), n.$currencySelect.val(t), Currency.currentCurrency = t, Currency.cookie.write(t), a(t)
            }, e = function() {
                n.$currencySelect.on("change", function() {
                    return u(t(this).val())
                })
            }, t(function() {
                "object" == typeof Currency && c()
            }), {
                init: c,
                cacheElements: i,
                convertAll: a,
                formatMoney: r,
                renderPrice: s,
                setCurrency: u
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        window.Station.Theme = window.Station.Theme || {}, Station.Theme.Customer = function(t) {
            var e, n, i, o;
            return i = {
                addressesTemplate: "customers/addresses",
                loginTemplate: "customers/login"
            }, o = Station.Theme.config, e = function() {
                var e, n, o, a, r, c, s, l, u, d, h, f;
                return u = {
                    addAddress: "#add_address",
                    addAddressButton: '[data-form-id="add_address"]:first',
                    customerAddress: ".customer-address",
                    customerAddressForm: ".customer-address form",
                    deleteAddress: ".delete-address",
                    editAddress: '[id^="edit_address"]',
                    errors: ".errors",
                    toggleAddress: ".toggle-address"
                }, n = {}, c = function() {
                    return o(), e(), l(), h()
                }, o = function() {
                    n = {
                        $addAddressButton: t(u.addAddressButton),
                        $pageHeaderTitle: t(u.pageHeaderTitle),
                        $customerAddress: t(u.customerAddress),
                        $customerAddressForm: t(u.customerAddressForm),
                        $deleteAddress: t(u.deleteAddress),
                        $toggleAddress: t(u.toggleAddress)
                    }
                }, a = function(t, e) {
                    confirm(e) && Shopify.postLink("/account/addresses/" + t, {
                        parameters: {
                            _method: "delete"
                        }
                    })
                }, r = function(t) {
                    t.hide()
                }, s = function(t) {
                    return new Shopify.CountryProvinceSelector("address_country_" + t, "address_province_" + t, {
                        hideElement: "address_province_row_" + t
                    })
                }, l = function() {
                    Shopify && s("new"), n.$customerAddress.not(u.addAddress).each(function() {
                        var e;
                        return e = t(this).attr("id").replace("address_", ""), Shopify ? s(e) : void 0
                    })
                }, d = function(e, n) {
                    e.show().addClass("animate-in fade-in-down"), n && n.length && n.velocity("scroll", {
                        duration: 500,
                        offset: -20,
                        easing: "easeInOutCirc"
                    }), Station.GrandCentral.Utilities.delay(20, function() {
                        return t('input[type="text"]', e).first().focus()
                    })
                }, h = function() {
                    return n.$customerAddressForm.each(function() {
                        var e, n;
                        e = t(this).closest(u.addAddress, u.editAddress), n = t(u.errors, t(this)), n.length && d(e, e)
                    })
                }, f = function(e, i) {
                    var o;
                    o = t(e), o.length && (o.is(":visible") ? (r(o), e === u.addAddress && (Station.Theme.Base.setPageTitle(), n.$addAddressButton.show())) : (e === u.addAddress && (i = t("#content-wrap"), n.$addAddressButton.hide(), Station.Theme.Base.setPageTitle(n.$addAddressButton.text())), d(o, i)))
                }, e = function() {
                    return n.$toggleAddress.on("click", function(e) {
                        e.preventDefault(), t(this).blur(), f("#" + t(this).data("form-id"), t(this))
                    }), n.$deleteAddress.on("click", function(e) {
                        e.preventDefault(), t(this).blur(), a(t(this).data("form-id"), t(this).data("confirm-message"))
                    })
                }, Station.Theme.current.templateType === i.addressesTemplate && c(), {
                    init: c,
                    cacheElements: o,
                    deleteAddress: a,
                    hideAddressForm: r,
                    initCountryProvinceSelector: s,
                    initCountryProvinceSelectors: l,
                    showAddressForm: d,
                    showAddressFormsWithErrors: h,
                    toggleAddress: f
                }
            }(), n = function() {
                var e, n, o, a, r, c, s;
                return c = {
                    loginSection: "#customer-login",
                    recoverPasswordSection: "#customer-recover-password",
                    recoverPasswordSuccess: "[data-recover-password-success]",
                    recoverPasswordSuccessTest: "#recover-password-success",
                    togglePasswordRecovery: ".toggle-password-recovery"
                }, n = {}, a = function() {
                    return o(), e(), s(), r(n.$recoverPasswordSuccess.length)
                }, o = function() {
                    n = {
                        $loginSection: t(c.loginSection),
                        $recoverPasswordSection: t(c.recoverPasswordSection),
                        $recoverPasswordSuccess: t(c.recoverPasswordSuccess),
                        $recoverPasswordSuccessTest: t(c.recoverPasswordSuccessTest),
                        $togglePasswordRecovery: t(c.togglePasswordRecovery)
                    }
                }, r = function(t) {
                    t && n.$recoverPasswordSuccessTest.show().removeClass("hidden")
                }, s = function() {
                    var t;
                    t = "#recover" === window.location.hash ? c.recoverPasswordSection : c.loginSection, Station.GrandCentral.Utilities.switchElement(c.loginSection + ", " + c.recoverPasswordSection, t)
                }, e = function() {
                    return n.$togglePasswordRecovery.on("click", function(e) {
                        e.preventDefault(), Station.GrandCentral.Utilities.switchElement(c.loginSection + ", " + c.recoverPasswordSection, "#" + t(this).data("show-module-id"), "animate-in fade-in-down")
                    })
                }, t(function() {
                    Station.Theme.current.templateType === i.loginTemplate && a()
                }), {
                    init: a,
                    cacheElements: o,
                    renderRecoverPasswordSuccess: r,
                    setInitialSection: s
                }
            }(), {
                Login: n,
                Addresses: e
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.Image = function(t) {
            var e, n, i, o, a, r, c, s, l, u, d;
            return i = Station.Theme.current, d = Station.Theme.config, e = function() {
                var e, n, o, a, r, c, h, f, m, p;
                return h = {
                    primaryImage: "div.primary-image",
                    secondaryImage: "div.secondary-image"
                }, o = {}, r = function() {
                    switch (a(), Station.Theme.current.templateType) {
                        case "product":
                            return i.secondaryImageIndex = t(h.secondaryImage + ".active:first").index() + 1, s(i.product.images, d.product.primaryImageSize), e(), n()
                    }
                }, a = function() {
                    return o = {
                        $primaryImage: t(h.primaryImage),
                        $primaryImageA: t("a:first", h.primaryImage),
                        $primaryImageImg: t("img:first", h.primaryImage),
                        $secondaryImage: t(h.secondaryImage)
                    }
                }, c = function() {
                    m(o.$primaryImage, "data-default", o.$secondaryImage.first())
                }, m = function(t, e, n) {
                    return l(o.$primaryImageImg, t.attr(e + "-src"), d.product.primaryImageSize, t.attr(e + "-alt"), t.attr(e + "-title"), t.attr(e + "-src")), o.$secondaryImage.length && f(n), o.$primaryImage.is("[zoom-enabled]") ? u(o.$primaryImage, t.attr(e + "-src")) : void 0
                }, p = function(e) {
                    var n, i, o, a, r, s, l;
                    for (a = !1, r = t(h.secondaryImage), i = 0, o = r.length; o > i; i++)
                        if (s = r[i], l = t(s).attr("data-variant-ids"), l && (l = JSON.parse(l)), t.inArray(e, l) > -1) {
                            a = !0, n = t(s), m(n, "data", n);
                            break
                        }
                    a || c()
                }, f = function(e) {
                    o.$secondaryImage.each(function() {
                        return t(this).removeClass("active")
                    }), e.addClass("active"), i.secondaryImageIndex = e.attr("data-image-index")
                }, e = function() {
                    d.product.enableLightbox && o.$primaryImage.on("click", function(e) {
                        var n, a;
                      e.preventDefault(), o.$secondaryImage.length ? (n = t("a:first", o.$secondaryImage), a = {
                            index: i.secondaryImageIndex - 1
                      }) : n = o.$primaryImageA, t.fancybox(n,a)
                   console.log(t);
                    })
                }, n = function() {
                    o.$secondaryImage.each(function() {
                        var e, n, i;
                        return n = t(this), e = t("a:first", n), i = n.data("image-index"), null == i && (i = n.index()), e.on("click", function(t) {
                            var e;
                            t.preventDefault(), e = n.attr("data-variant-ids"), e = JSON.parse(e), e.length > 0 && d.product.enableSetVariantFromSecondary ? Station.Theme.Product.setVariantByID(e[0], d.product.enableDeepLinking) : m(n, "data", n)
                        })
                    })
                }, {
                    init: r,
                    cacheElements: a,
                    setZoom: u,
                    resetImages: c,
                    setImagesFromVariantID: p,
                    setActiveSecondaryImage: f,
                }
            }(), r = function() {
                return n(), e.init()
            }, a = function(t, e) {
                var n, i, o;
                return null === e ? t : "master" === e ? Station.GrandCentral.Utilities.removeProtocol(t) : (i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i), null !== i ? (o = t.split(i[0]), n = i[0], Station.GrandCentral.Utilities.removeProtocol(o[0] + "_" + e + n)) : void 0)
            }, o = function(t) {
                var e;
                return e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/), null !== e ? e[1] : null
            }, c = function(t) {
                (new Image).src = t
            }, s = function(t, e) {
                var n, i, o;
                for (n = 0, i = t.length; i > n; n++) o = t[n], c(a(o, e))
            }, l = function(t, e, n, i, o, r) {
                var c;
                t && (c = t.closest("a"), e || (e = t.attr("data-default-src"), i = t.attr("data-default-alt"), o = t.attr("data-default-title"), r = t.attr("data-default-href")), n && (e = a(e, n)), e !== t.attr("src") && (t.attr("src", e).attr("alt", i).attr("data-title", o), c.attr("href", r)))
            }, u = function(e, n) {
                e && (t(e).trigger("zoom.destroy"), e.zoom({
                    url: n,
                    touch: !1,
                    duration: 0,
                    callback: function() {
                        return this.naturalWidth <= e.parent().width() ? e.css("width", this.naturalWidth + "px") : e.css("width", "initial"), this.naturalHeight <= e.parent().height() ? e.css("height", this.naturalHeight + "px") : e.css("height", "initial")
                    }
                }))
            }, n = function() {}, t(function() {
                r()
            }), {
                Product: e,
                init: r,
                getSize: o,
                getSizedUrl: a,
                load: c,
                preload: s,
                setImage: l,
                setZoom: u
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.Password = function(t) {
            var e, n, i, o, a, r, c, s;
            return a = {
                page: "html.password",
                pageModule: "html.password .password-module",
                enterLink: "html.password .enter-link",
                cancelEnterLink: "html.password .cancel-enter-link",
                input: "html.password input#password",
                emailInput: "html.password input#email",
                moduleLogin: "#password-entry",
                moduleNotice: "#opening-soon"
            }, s = Station.Theme.config, n = {}, o = function() {
                i(), e(), "password" === Station.Theme.current.templateType && (t(".errors", a.moduleLogin).length && r(), n.$enterLink.first().on("click", function() {
                    r()
                }), n.$cancelEnterLink.first().on("click", function() {
                    c()
                }))
            }, r = function() {
                Station.GrandCentral.Utilities.switchElement(a.pageModule, "#" + n.$enterLink.data("show-module-id"), "animate-in fade-in-down"), n.$enterLink.hide(), n.$cancelEnterLink.show(), n.$input.focus()
            }, c = function() {
                Station.GrandCentral.Utilities.switchElement(a.pageModule, "#" + n.$cancelEnterLink.data("show-module-id"), "animate-in fade-in-down"), n.$cancelEnterLink.hide(), n.$enterLink.show(), n.$emailInput.focus()
            }, i = function() {
                n = {
                    $cancelEnterLink: t(a.cancelEnterLink),
                    $enterLink: t(a.enterLink),
                    $input: t(a.input),
                    $emailInput: t(a.emailInput),
                    $page: t(a.page)
                }
            }, e = function() {
                t(document).keyup(function(t) {
                    27 === t.keyCode && c()
                })
            }, t(function() {
                o()
            }), {
                init: o,
                cacheElements: i
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        Station.Theme = Station.Theme || {}, Station.Theme.Product = function(t) {
            var e, n, i, o, a, r, c, s, l, u, d, h, f, m, p, y, v, S, g, C, T, w, b, $;
            return f = {
                addToCart: ".primary .add-to-cart",
                basePrice: ".primary [data-base-price]",
                backorderNotice: ".primary .backorder-notice",
                currency: ".primary [data-currency]",
                currencyCode: ".primary [data-currency-code]",
                from: ".primary .from",
                optionSelector: ".primary [data-option-selector]",
                price: ".primary [data-price]",
                priceCompareAt: ".primary .compare-at",
                priceSell: ".primary .sell-price",
                qty: ".primary #quantity",
                qtyAvailable: ".primary [data-quantity-available]",
                saleSticker: ".primary .sale-sticker",
                sku: ".primary [data-sku]:not(option)",
                variantID: 'input[name="id"]'
            }, c = Station.Theme.current, $ = Station.Theme.config, r = {
                i18n: Station.Theme.i18n,
                currentCurrency: c.currency,
                currentProduct: c.product,
                currentVariant: c.variant,
                renderPrice: Station.Theme.Currency.renderPrice,
                shop: Station.Theme.shop,
                templateType: c.templateType,
                utilities: Station.GrandCentral.Utilities
            }, o = {}, d = function(t) {
                return a(), "product" === r.templateType && (e(), i(), n()), $.product.enableQtyLimit ? s() : void 0
            }, a = function() {
                return o = {
                    $addToCart: t(f.addToCart),
                    $basePrice: t(f.basePrice),
                    $backorderNotice: t(f.backorderNotice),
                    $currency: t(f.currency),
                    $currencyCode: t(f.currencyCode),
                    $from: t(f.from),
                    $optionSelector: t(f.optionSelector),
                    $price: t(f.price),
                    $priceCompareAt: t(f.priceCompareAt),
                    $priceSell: t(f.priceSell),
                    $qty: t(f.qty),
                    $qtyAvailable: t(f.qtyAvailable),
                    $saleSticker: t(f.saleSticker),
                    $sku: t(f.sku),
                    $variantID: t(f.variantID)
                }
            }, l = function(e) {
                var n;
                return n = null, t.each(r.currentProduct.variants, function(t, i) {
                    return i.id === parseInt(e) ? (n = i, !1) : void 0
                }), n
            }, u = function(e, n) {
                var i, a, c;
                return null == n && (n = o.$optionSelector), i = [], a = null, c = e ? e.variants : r.currentProduct.variants, n.each(function() {
                    var e;
                    return e = parseInt(t(this).data("option-number")), i.splice(e, 0, t("option:selected", this).text())
                }), t.each(c, function(t, e) {
                    return Station.GrandCentral.Utilities.arraysEqual(i, e.options) ? (a = e, !1) : void 0
                }), a
            }, h = function(t) {
                return "continue" === t.inventory_policy && t.inventory_quantity <= 0
            }, s = function(e, n) {
                n = n > 0 ? n : 1, e = 0 > e ? 0 : e, o.$qty.each(function() {
                    var i;
                    return i = t(this), i.attr("min", n), i.attr("max", e), 0 === e && i.removeAttr("max"), i.on("change", function() {
                        var t;
                        return n = parseInt(i.attr("min")), e = parseInt(i.attr("max")), t = parseInt(i.val()), 0 === e && (t = 0), n >= t && (t = n), t >= e && (t = e), i.val(t)
                    }), t(this).trigger("change")
                })
            }, m = function(t, e) {
                t || (t = e ? r.i18n.product.addToCart : r.i18n.product.soldOut), o.$addToCart.text(t), e ? o.$addToCart.prop("disabled", !1).removeClass("disabled") : o.$addToCart.prop("disabled", !0).addClass("disabled")
            }, p = function(t, e) {
                t && o.$backorderNotice.html(t), e === !1 ? o.$backorderNotice.addClass("hidden") : o.$backorderNotice.removeClass("hidden")
            }, y = function(t, e) {
                t && o.$priceCompareAt.html(t), e === !1 ? o.$priceCompareAt.addClass("hidden") : o.$priceCompareAt.removeClass("hidden")
            }, v = function(t, e) {
                0 > t && (t = 0), o.$qtyAvailable.text(t), e === !1 ? o.$qtyAvailable.parent().hide() : o.$qtyAvailable.parent().show()
            }, S = function(t) {
                t = "boolean" == typeof t ? t : t.compare_at_price > t.price, t ? (o.$saleSticker.removeClass("hidden"), $.product.enableHighlightAddWhenSale && o.$addToCart.addClass("focus")) : (o.$saleSticker.addClass("hidden"), o.$addToCart.removeClass("focus"))
            }, g = function() {
                o.$optionSelector.each(function() {
                    var e;
                    return t(this).val() ? void 0 : (e = t("option:selected", t(this)).text(), o.$priceSell.text(e), m(e), !1)
                })
            }, C = function(t, e) {
                o.$sku.text(t), e === !1 ? o.$sku.parent().hide() : o.$sku.parent().show()
            }, T = function(t, e) {
                t ? (c.variant = t, b(), r.renderPrice(f.priceSell, t.price), r.renderPrice(f.priceCompareAt, t.compare_at_price), y(null, t.compare_at_price), v(t.inventory_quantity), C(t.sku), S(t), p(null, h(t)), m("", t.available), Station.Theme.Image.Product.setImagesFromVariantID(t.id), $.product.enableQtyLimit && s(t.inventory_quantity), e && r.utilities.setParam("variant", t.id)) : (c.variant = null, b(), r.renderPrice(f.priceSell, r.i18n.product.unavailable), r.renderPrice(f.priceCompareAt), y(null, !1), v(0), C("", !1), S(!1), p(null, !1), m(r.i18n.product.unavailable, !1), Station.Theme.Image.Product.resetImages(), $.product.enableQtyLimit && s(0, 0)), g()
            }, b = function(t, e) {
                t || (t = null !== c.variant ? c.variant.id : ""), e || (e = o.$variantID), e.val(t)
            }, w = function(e, n) {
                var i;
                e && (i = l(e)) && (o.$optionSelector.each(function(e, n) {
                    t(this).val(i["option" + (e + 1)])
                }), T(i, n))
            }, e = function() {
                o.$optionSelector.each(function() {
                    return t(this).on("change", function() {
                        var t;
                        return t = u(r.currentProduct, o.$optionSelector), T(t, $.product.enableDeepLinking)
                    })
                })
            }, n = function() {
                $.product.enableSelectAnOption && o.$optionSelector.length > 1 && (o.$optionSelector.each(function(e, n) {
                    var i, o;
                    return o = t(this).data("select-text"), null == o && (o = currentProduct.options[e]), i = '<option value="">' + o + "</option>", t(this).prepend(i).val("")
                }), o.$optionSelector.first().trigger("change"))
            }, i = function() {
                var t;
                t = Station.GrandCentral.Utilities.getParam("variant"), t && (r.currentVariant = l(t)), T(r.currentVariant, !1), $.product.showPrimaryImageFirst && !t && Station.Theme.Image.Product.resetImages()
            }, t(function() {
                d()
            }), {
                init: d,
                cacheElements: a,
                getVariantByID: l,
                getVariantBySelectors: u,
                isOnBackorder: h,
                enableQtyLimit: s,
                setAddToCartButtons: m,
                setBackorderNotice: p,
                setCompareAtPrice: y,
                setQtyAvailable: v,
                setSale: S,
                setSelectAnOption: g,
                setSku: C,
                setVariant: T,
                setVariantByID: w
            }
        }(jQuery.noConflict())
    }.call(this),
    function() {
        var t;
        window.Station.Theme = window.Station.Theme || {}, Station.Theme.Sections = function() {
                var t;
                t = jQuery, this.constructors = {}, this.instances = [], t(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
            },
            function(t) {
                return t(function() {
                    var t;
                    t = new Station.Theme.Sections, t.register("collection", Station.Theme.CollectionSection), t.register("collection-template", Station.Theme.CollectionTemplateSection), t.register("footer", Station.Theme.FooterSection), t.register("header", Station.Theme.HeaderSection), t.register("password-template", Station.Theme.PasswordTemplateSection), t.register("product-template", Station.Theme.ProductTemplateSection), t.register("sidebar", Station.Theme.SidebarSection), t.register("slideshow", Station.Theme.SlideshowSection), t.register("video", Station.Theme.VideoSection)
                })
            }(jQuery.noConflict()), Station.Theme.Sections.prototype = _.assignIn({}, Station.Theme.Sections.prototype, t = jQuery, {
                _createInstance: function(e, n) {
                    var i, o, a, r;
                    return i = t(e), o = i.attr("data-section-id"), r = i.attr("data-section-type"), n = n || this.constructors[r], null != n ? (a = _.assignIn(new n(e), {
                        id: o,
                        type: r,
                        container: e
                    }), this.instances.push(a), a) : void 0
                },
                _onSectionLoad: function(e) {
                    var n, i;
                    n = t("[data-section-id]", e.target)[0], n && (i = this._createInstance(n), null != i && _.isFunction(i.onLoad) && i.onLoad(e))
                },
                _onSectionUnload: function(t) {
                    this.instances = _.filter(this.instances, function(e) {
                        var n;
                        return n = e.id === t.detail.sectionId, n && _.isFunction(e.onUnload) && e.onUnload(t), !n
                    })
                },
                _onSelect: function(t) {
                    var e;
                    e = _.find(this.instances, function(e) {
                        return e.id === t.detail.sectionId
                    }), null != e && _.isFunction(e.onSelect) && e.onSelect(t)
                },
                _onDeselect: function(t) {
                    var e;
                    e = _.find(this.instances, function(e) {
                        return e.id === t.detail.sectionId
                    }), null != e && _.isFunction(e.onDeselect) && e.onDeselect(t)
                },
                _onBlockSelect: function(t) {
                    var e;
                    e = _.find(this.instances, function(e) {
                        return e.id === t.detail.sectionId
                    }), null != e && _.isFunction(e.onBlockSelect) && e.onBlockSelect(t)
                },
                _onBlockDeselect: function(t) {
                    var e;
                    e = _.find(this.instances, function(e) {
                        return e.id === t.detail.sectionId
                    }), null != e && _.isFunction(e.onBlockDeselect) && e.onBlockDeselect(t)
                },
                register: function(e, n) {
                    this.constructors[e] = n, t("[data-section-type=" + e + "]").each(function(t, e) {
                        this._createInstance(e, n)
                    }.bind(this))
                }
            })
    }.call(this),
    function() {
        var t;
        Station.Theme = Station.Theme || {}, Station.Theme.CollectionTemplateSection = function(t) {
            var e;
            return e = function(e) {
                this.$container = t(e), this.sectionId = this.$container.attr("data-section-id")
            }
        }(jQuery.noConflict()), Station.Theme.CollectionTemplateSection.prototype = _.assignIn({}, Station.Theme.CollectionTemplateSection.prototype, t = jQuery, {
            onLoad: function(t) {
                Station.Theme.Cart.init()
            },
            onSelect: function(t) {
                return Station.Theme.Cart.init(), Station.Theme.Collection.init(), Station.Theme.Currency.init()
            },
            onBlockSelect: function(t) {
                Station.Theme.Currency.init()
            }
        })
    }.call(this),
    function() {
        var t;
        Station.Theme = Station.Theme || {}, Station.Theme.FooterSection = function(t) {
            var e;
            return e = function(e) {
                this.$container = t(e), this.sectionId = this.$container.attr("data-section-id")
            }
        }(jQuery.noConflict()), Station.Theme.FooterSection.prototype = _.assignIn({}, Station.Theme.FooterSection.prototype, t = jQuery, {
            onSelect: function(t) {
                Station.GrandCentral.Accordions.init(), Station.GrandCentral.NavSide.init(), Station.GrandCentral.Notify.init(), Station.GrandCentral.Tabs.init(), "object" == typeof twttr && twttr.widgets.load()
            },
            onBlockSelect: function(t) {
                Station.Theme.Currency.init()
            }
        })
    }.call(this),
    function() {
        var t;
        Station.Theme = Station.Theme || {}, Station.Theme.HeaderSection = function(t) {
            var e;
            return e = function(e) {
                this.$container = t(e), this.sectionId = this.$container.attr("data-section-id")
            }
        }(jQuery.noConflict()), Station.Theme.HeaderSection.prototype = _.assignIn({}, Station.Theme.HeaderSection.prototype, t = jQuery, {
            onSelect: function(t) {
                Station.GrandCentral.NavPrimary.init()
            }
        })
    }.call(this),
    function() {
        var t;
        Station.Theme = Station.Theme || {}, Station.Theme.PasswordTemplateSection = function(t) {
            var e;
            return e = function(e) {
                this.$container = t(e), this.sectionId = this.$container.attr("data-section-id")
            }
        }(jQuery.noConflict()), Station.Theme.PasswordTemplateSection.prototype = _.assignIn({}, Station.Theme.PasswordTemplateSection.prototype, t = jQuery, {
            onSelect: function(t) {
                Station.Theme.Password.init()
            }
        })
    }.call(this),
    function() {
        var t;
        Station.Theme = Station.Theme || {}, Station.Theme.ProductTemplateSection = function(t) {
            var e;
            return e = function(e) {
                this.$container = t(e), this.sectionId = this.$container.attr("data-section-id")
            }
        }(jQuery.noConflict()), Station.Theme.ProductTemplateSection.prototype = _.assignIn({}, Station.Theme.ProductTemplateSection.prototype, t = jQuery, {
            onSelect: function(t) {
                Station.Theme.Cart.init(), Station.Theme.Image.Product.init(), Station.Theme.Product.init()
            }
        })
    }.call(this),
    function() {
        var t;
        Station.Theme = Station.Theme || {}, Station.Theme.SidebarSection = function(t) {
            var e;
            return e = function(e) {
                this.$container = t(e), this.sectionId = this.$container.attr("data-section-id")
            }
        }(jQuery.noConflict()), Station.Theme.SidebarSection.prototype = _.assignIn({}, Station.Theme.SidebarSection.prototype, t = jQuery, {
            onSelect: function(t) {
                Station.GrandCentral.Accordions.init(), Station.GrandCentral.NavSide.init(), Station.GrandCentral.Notify.init(), Station.GrandCentral.Tabs.init(), "object" == typeof twttr && twttr.widgets.load()
            },
            onBlockSelect: function(t) {
                Station.Theme.Currency.init()
            }
        })
    }.call(this),
    function() {
        var t;
        Station.Theme = Station.Theme || {}, Station.Theme.SlideshowSection = function(t) {
            var e;
            return e = function(e) {
                this.$container = t(e), this.sectionId = this.$container.attr("data-section-id"), this.carousel = "#gc-carousel-" + this.sectionId, this.$carousel = t(this.carousel)
            }
        }(jQuery.noConflict()), Station.Theme.SlideshowSection.prototype = _.assignIn({}, Station.Theme.SlideshowSection.prototype, t = jQuery, {
            onLoad: function(t) {
                Station.GrandCentral.Vendor.Flickity.initCarousel(this.$carousel)
            },
            onSelect: function(t) {
                Station.GrandCentral.Vendor.Flickity.initCarousel(this.$carousel)
            },
            onBlockSelect: function(e) {
                var n, i, o;
                n = t(".section-block", this.$carousel), i = t('*[data-block-id="' + e.detail.blockId + '"]', this.$carousel), o = n.index(i), Station.GrandCentral.Vendor.Flickity.initCarousel(this.$carousel), this.$carousel.flickity("pausePlayer").flickity("select", o)
            },
            onBlockDeselect: function() {
                this.$carousel.flickity("unpausePlayer")
            }
        })
    }.call(this),
    function() {
        var t;
        Station.Theme = Station.Theme || {}, Station.Theme.VideoSection = function(t) {
            var e;
            return e = function(e) {
                this.$container = t(e), this.sectionId = this.$container.attr("data-section-id")
            }
        }(jQuery.noConflict()), Station.Theme.VideoSection.prototype = _.assignIn({}, Station.Theme.VideoSection.prototype, t = jQuery, {
            onLoad: function(t) {
                Station.Theme.Base.initFitVids()
            },
            onSelect: function(t) {
                Station.Theme.Base.initFitFids()
            }
        })
    }.call(this);
